__turbopack_context__.v({
  "container": "lupi3a_container",
  "hoverContainer": "lupi3a_hoverContainer",
  "hoverContainerActive": "lupi3a_hoverContainerActive",
  "menuList": "lupi3a_menuList",
  "menuListItem": "lupi3a_menuListItem",
  "menuListItemButton": "lupi3a_menuListItemButton",
  "navCategoryListNarrow": "lupi3a_navCategoryListNarrow",
  "navCategoryListWide": "lupi3a_navCategoryListWide",
});
